var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInaktiv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_169",
    "data-name": "Gruppe 169",
    transform: "translate(-286 -52)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_48",
    "data-name": "Ellipse 48",
    cx: 11.5,
    cy: 11.5,
    r: 11.5,
    transform: "translate(286 52)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_165",
    "data-name": "Gruppe 165",
    transform: "translate(-26.499 -1493.499)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_21",
    "data-name": "Pfad 21",
    d: "M798.045,2562.449l9.844-9.844",
    transform: "translate(-479 -1000)",
    fill: "none",
    stroke: "#de3c4b",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_22",
    "data-name": "Pfad 22",
    d: "M0,9.844,9.844,0",
    transform: "translate(328.889 1552.605) rotate(90)",
    fill: "none",
    stroke: "#de3c4b",
    strokeLinecap: "round",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInaktiv);
export default __webpack_public_path__ + "static/media/Inaktiv.1ee8289673c67bf06fb9541728d83ffd.svg";
export { ForwardRef as ReactComponent };